import { IntlShape } from 'react-intl'

import {
  EquipmentSpecialTypeEnum,
  QuestionTypeEnum,
} from '../../../lib/graphql'

export type FAQDefaultQuestionsType = {
  [key in QuestionTypeEnum]: {
    question: string
    equipmentSpecialTypes?: EquipmentSpecialTypeEnum[]
  }
}

// If you touch this object make sure to also update: house-faq.constants.ts
export const questionAndAnswerDefaultQuestions = ({
  intl,
}: {
  intl: IntlShape
}): FAQDefaultQuestionsType => ({
  [QuestionTypeEnum.Q1]: {
    question: intl.formatMessage({
      id: 'bo.house.faq.question1',
      defaultMessage: 'Quelles activités recommandez-vous à proximité ?',
    }),
  },
  [QuestionTypeEnum.Q2]: {
    question: intl.formatMessage({
      id: 'bo.house.faq.question2',
      defaultMessage:
        'Pouvez-vous décrire les équipements de loisir disponibles sur place ?',
    }),
  },
  [QuestionTypeEnum.Q3]: {
    question: intl.formatMessage({
      id: 'bo.house.faq.question3',
      defaultMessage:
        "Quelles sont vos conditions d'annulation totale et partielle ?",
    }),
  },
  [QuestionTypeEnum.EQUIPMENTQ1]: {
    question: intl.formatMessage({
      id: 'bo.house.faq.question4',
      defaultMessage: "Quelles sont les règles d'utilisation de la piscine ?",
    }),
    equipmentSpecialTypes: [
      EquipmentSpecialTypeEnum.POOL,
      EquipmentSpecialTypeEnum.SPA,
    ],
  },
})
